import React from "react";
import { Routes, Route } from "react-router-dom";
import AppCMS from "./AppCMS";
import { Toaster } from "react-hot-toast";
import MainBlog from "./MainEp/Blogs/MainBlog";
import MainColleges from "./CommonAPI/Colleges/MainColleges";
import MainPrograms from "./CommonAPI/Programs/MainPrograms";
import MainIntakes from "./CommonAPI/Intakes/MainIntakes";
import MainPromoCode from "./CommonAPI/PromoCode/MainPromoCode";
import Announcements from "./CommonAPI/Announcements/Announcements";
import MainSuccess360Page from "./CommonAPI/Success-360/MainSuccess360Page";
import MainSuccess360Banner from "./CommonAPI/Success360-Banner/MainSuccess360Banner";
import MainOurService from "./CommonAPI/Our-Service/MainOurService";
import MainBanners from "./CommonAPI/Banner/MainBanners";
import MainEventsWebinars from "./MainEp/Event-Webinars/Main";
import MainSearchHistory from "./MainEp/ManageSearch/MainSearchHistory";

function RoutesCMS() {
  return (
    <div>
      <Routes>
        <Route path="/cms" element={<AppCMS />}>
          <Route path="common-api/colleges" element={<MainColleges />} />
          <Route path="common-api/programs" element={<MainPrograms />} />
          <Route path="common-api/intakes" element={<MainIntakes />} />

          <Route path="common-api/promo-code" element={<MainPromoCode />} />

          <Route path="main-ep/blogs" element={<MainBlog />} />
          <Route
            path="main-ep/events-webinars"
            element={<MainEventsWebinars />}
          />

          <Route
            path="main-ep/search-history"
            element={<MainSearchHistory />}
          />
          <Route path="common-api/announcements" element={<Announcements />} />
          <Route
            path="common-api/success-360"
            element={<MainSuccess360Page />}
          />
          <Route path="common-api/our-services" element={<MainOurService />} />
          <Route
            path="common-api/success360-banner"
            element={<MainSuccess360Banner />}
          />

          <Route path="common-api/banners" element={<MainBanners />} />
        </Route>
      </Routes>
      <div>
        <Toaster reverseOrder={false} containerClassName="fs-4" />
      </div>
    </div>
  );
}

export default RoutesCMS;
